import { SectionHeading } from "../components/SectionHeading";
import { Reveal } from "../components/Reveal";

export const AboutStrip = () => (
  <section id="about" data-testid="about-section" className="bg-brand-mist py-24 sm:py-32">
    <div className="max-w-7xl mx-auto px-5 sm:px-8 grid lg:grid-cols-2 gap-14 items-center">
      <div>
        <SectionHeading
          kicker="About MODORS"
          title="A Focused Steel Frame Manufacturer"
        />
        <Reveal delay={0.15}>
          <p className="mt-6 text-lg text-brand-ink/70 leading-relaxed">
            MODORS combines galvanized steel, precision forming technology and skilled
            fabrication to deliver dependable door and window frame solutions for the
            construction industry.
          </p>
        </Reveal>
        <Reveal delay={0.22}>
          <p className="mt-5 text-base text-brand-ink/55 leading-relaxed">
            Manufactured by S R Engineers and Fabricators in Gurugram, Haryana, every frame
            is produced with quality-focused, standardized manufacturing — built for repeat
            orders, project timelines and professional site requirements.
          </p>
        </Reveal>
        <Reveal delay={0.3}>
          <div className="mt-9 grid grid-cols-3 gap-px bg-black/10 border border-black/10">
            {[
              ["Material", "GPSP Steel"],
              ["Made In", "Gurugram, HR"],
              ["Supply", "B2B / Projects"],
            ].map(([k, v]) => (
              <div key={k} className="bg-white p-4 sm:p-5">
                <div className="text-[10px] font-semibold tracking-[0.22em] uppercase text-brand-red">{k}</div>
                <div className="mt-1.5 font-display text-sm sm:text-base font-semibold uppercase text-brand-ink">{v}</div>
              </div>
            ))}
          </div>
        </Reveal>
      </div>
      <Reveal delay={0.1}>
        <div className="relative bg-white border border-black/10 overflow-hidden group">
          <span className="absolute top-0 left-0 w-10 h-10 border-t-2 border-l-2 border-brand-red z-10" />
          <span className="absolute bottom-0 right-0 w-10 h-10 border-b-2 border-r-2 border-brand-red z-10" />
          <img
            src="/brand/about-studio.jpg"
            alt="MODORS galvanized steel door frames — strong, precise, built to last"
            className="w-full h-[380px] sm:h-[480px] object-cover transition-transform duration-700 group-hover:scale-[1.03]"
          />
        </div>
      </Reveal>
    </div>
  </section>
);
